import React from "react";
import { Link } from "react-router-dom";
import { Star, ShoppingCart } from "@phosphor-icons/react";
import { useCart } from "../lib/cart";
import { Button } from "./ui/button";
import { Badge } from "./ui/badge";

export const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const discount =
    product.original_price && product.original_price > product.price
      ? Math.round(
          ((product.original_price - product.price) / product.original_price) *
            100,
        )
      : 0;

  return (
    <div
      className="border border-zinc-200 bg-white flex flex-col hard-shadow group"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/products/${product.id}`} className="block relative">
        <div className="aspect-square bg-zinc-50 border-b border-zinc-200 overflow-hidden">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            loading="lazy"
          />
        </div>
        {product.is_deal && (
          <Badge
            className="absolute top-3 left-3 rounded-none bg-[#FF2A00] text-white font-mono uppercase tracking-wider hover:bg-[#FF2A00]"
            data-testid={`deal-badge-${product.id}`}
          >
            Deal
          </Badge>
        )}
        {discount > 0 && (
          <div className="absolute top-3 right-3 bg-zinc-950 text-white font-mono text-xs font-bold px-2 py-1">
            -{discount}%
          </div>
        )}
      </Link>

      <div className="p-4 flex flex-col flex-1 gap-3">
        <div className="flex items-center justify-between">
          <span className="font-mono uppercase text-[10px] tracking-[0.2em] text-zinc-500">
            {product.brand}
          </span>
          <div className="flex items-center gap-1 text-xs">
            <Star size={12} weight="fill" className="text-amber-500" />
            <span className="font-mono">{product.rating}</span>
            <span className="text-zinc-400">({product.reviews_count})</span>
          </div>
        </div>

        <Link to={`/products/${product.id}`}>
          <h3 className="font-heading font-bold text-base leading-snug line-clamp-2 hover:underline">
            {product.name}
          </h3>
        </Link>

        <div className="mt-auto flex items-end justify-between gap-2 pt-2 border-t border-zinc-100">
          <div>
            {product.original_price && product.original_price > product.price && (
              <div className="text-xs text-zinc-400 line-through font-mono">
                ${product.original_price.toFixed(2)}
              </div>
            )}
            <div className="font-mono text-xl font-bold tracking-tight text-zinc-950">
              ${product.price.toFixed(2)}
            </div>
          </div>
          <Button
            size="sm"
            data-testid={`add-to-cart-${product.id}`}
            onClick={(e) => {
              e.preventDefault();
              addItem(product, 1);
            }}
            className="rounded-none bg-zinc-950 hover:bg-[#002FA7] text-white font-bold"
          >
            <ShoppingCart size={16} weight="bold" />
          </Button>
        </div>
      </div>
    </div>
  );
};
